// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  data: __t.string(),
  dayNumber: __t.u32(),
  money: __t.i64(),
  ratingAvg: __t.f32(),
  luxuryTier: __t.u32(),
  restaurantOpen: __t.bool(),
  freeSeats: __t.u32(),
};
